import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'

export default class extends Controller {
  static targets = ['subtextContainer']

  static values = {
    refreshUrl: String
  }

  displaySubtext(event) {
    this.subtextContainerTarget.innerHTML = event.target.dataset.subtext
  }

  refreshCalculations(event) {
    const form = event.target.closest('form')
    const formData = new FormData(form)
    const formDataObj = Object.fromEntries(formData.entries())

    get(this.refreshUrlValue, {
      responseKind: 'turbo-stream',
      query: formDataObj
    })
  }
}
